/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.JobWork {

    import fld = JobWorkReturnItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class JobWorkReturnItemsEditor extends _Ext.ItemGridEditor<JobWorkReturnItemsRow> {


        protected getColumnsKey() { return "JobWork.JobWorkReturnItems"; }
        protected getDialogType() { return JobWorkReturnItemsDialog; }
        protected getLocalTextPrefix() { return JobWorkReturnItemsRow.localTextPrefix; }
        protected form: JobWorkReturnItemsForm;

        private pendingChanges: Q.Dictionary<any> = {};

        // #region Variables
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public LaborMarkup: number;
        public ExchangeRate: number;
        public DeptId: number; 
        private GenSKU = true;   
        public boms: any[];//for Bom Validations
        // #endregion


        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: true, }); 

            var skuvalue = q.ToBool(TabAurous.GetConfigValue(1004));
            if (skuvalue == true)
                this.GenSKU = true;
            else
                this.GenSKU = false;

            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as JobWorkReturnDialog).CalculateAmountandTax(this.view.getItems(), this.view.getItems().length);
                }
            })
        }
        protected createSlickGrid(): Slick.Grid {
            var grid = super.createSlickGrid();
            grid.setSelectionModel(new Slick.RowSelectionModel());
            return grid;
        }



        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();

            var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);
            var str = ctx => ColumnFormatter.stringInputFormatter(ctx, this);

            var Department = Q.first(columns, x => x.field === fld.DepartmentId);
            Department.referencedFields = [fld.DepartmentId];
            Department.format = ctx => ColumnFormatter.selectFormatter(ctx, fld.DepartmentId, OMS.DepartmentMasterRow.getLookup(),this);

            if (this.GenSKU == false) {
                Q.first(columns, x => x.field === fld.Pieces).format = int;
            }
            Q.first(columns, x => x.field === fld.Discount).format = num;
            Q.first(columns, x => x.field === fld.WstPer).format = num;


            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        // #endregion 
        //#region  ItemGrid Inline Editor
        // **** Delete event handler ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);
            if (e.isDefaultPrevented())
                return;
            this.slickGrid.setSelectedRows([row]);
            var item = this.itemAt(row);
            var target = $(e.target);
            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();
            if (target.hasClass('inline-action')) {
                e.preventDefault();
                if (target.hasClass('delete-row')) {
                    Q.confirm('Are you sure want to delete? ', () => {

                        var id = this.id(item); 
                        this.view.deleteItem(id);
                        // }

                    });
                    this.view.refresh();
                    (this.parentDialog as JobWorkReturnDialog).CalculateAmountandTax(this.view.getItems(), this.view.getItems().length);
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
        }


        //#region Inline Editor
        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject, ) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.Pieces || field === fld.Discount) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0) {

                if (item.CalcOnId == 3) {
                    item.GrossAmount = item.UnitRate * value;
                    item.Weight = item.Pieces < value ? item.Weight * value : (item.Weight / item.Pieces) * value;
                    item.DiamondPieces = item.Pieces < value ? item.DiamondPieces * value : (item.DiamondPieces / item.Pieces) * value;
                    item.DiamondWeight = item.Pieces < value ? item.DiamondWeight * value : (item.DiamondWeight / item.Pieces) * value;
                    item.DiamondAmount = item.Pieces < value ? item.DiamondAmount * value : (item.DiamondAmount / item.Pieces) * value;
                    item.StonePieces = item.Pieces < value ? item.StonePieces * value : (item.StonePieces / item.Pieces) * value;
                    item.StoneWeight = item.Pieces < value ? item.StoneWeight * value : (item.StoneWeight / item.Pieces) * value;
                    item.StoneAmount = item.Pieces < value ? item.StoneAmount * value : (item.StoneAmount / item.Pieces) * value;
                    item.OtherPieces = item.Pieces < value ? item.OtherPieces * value : (item.OtherPieces / item.Pieces) * value;
                    item.OtherWeight = item.Pieces < value ? item.OtherWeight * value : (item.OtherWeight / item.Pieces) * value;
                    item.OtherAmount = item.Pieces < value ? item.OtherAmount * value : (item.OtherAmount / item.Pieces) * value;
                    item.NetWeight = item.Pieces < value ? item.NetWeight * value : (item.NetWeight / item.Pieces) * value;
                    if (item.WstPer != null) {
                        item.WstWt = item.NetWeight * (item.WstPer / 100);
                    }
                    item[field] = value;

                    this.view.updateItem(id, item);
                    this.view.refresh();
                }

            }
            // *** Calculate Wastage ***
            if (field === fld.WstPer && value >= 0) {
                item.WstWt = item.NetWeight * (value / 100);
                item[field] = value;
            }

            // *** Calculate Discount ***
            if (field === fld.Discount && value >= 0) {
                item.GrossAmount = item.NetAmount - value;
                item[field] = value;

            }

            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;

            }

            this.view.updateItem(id, item);
            this.view.refresh();
            (this.parentDialog as JobWorkReturnDialog).CalculateAmountandTax(this.view.getItems(), this.view.getItems().length);
            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }


        // #endregion


        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");

            let grid;
            // *** Add Select Button to Grid Editor ***
            buttons.push({
                title: "Select Products",
                cssClass: "add-button",
                hotkey: "Alt+K",
                onClick: () => {
                    // **** Validate Party before Item Selection ****
                    if (isNaN(this.PartyId)) {
                        Q.notifyWarning("Please select Supplier to proceed");
                        return;

                    }
                    else {
                        grid = JobWorkItemsSelectGrid;
                        //= this.PartyId;
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true, title: "Select Products"
                        });
                    }
                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        //alert('Length' + selectedItems.length);
                        var self = this;
                        var orddetails = []; 
                        var laborListId = this.LaborListId;
                        var laborMarkup = this.LaborMarkup; 
                        // #region Items to Grid
                        //for (let value of selectedItems2)
                        selectedItems2.forEach(function (value) {
                            var PrdId = value.ProductId;
                            var AtbId = value.AttributeId; 
                            var labordetail = []; 
                            // #region Product Attributes
                            // **** Load & assign Attributes of Product using AtbID ****
                             

                            // #region Rate, Tax , SKU & Labor 
                            var Rate = 0;
                            var LaborRate = 0;
                            var SKU = "";
                            // **** Get SKU for Item ****
                            var val = self.GenSKU;
                            if (self.GenSKU == true)
                                SKU = FormatHelper.GetFormats("SKU");
                            else
                                SKU = "";
                            var laborcaloptions: RateHelper.LaborCalOptions = {
                                ProductId: PrdId,
                                AttributeId: AtbId,
                                RateListId: laborListId,
                                Markup: laborMarkup,
                                Pieces: value.Pieces,
                                Weight: 0,
                                NetWeight: 0,
                                TransDate: new Date,
                                IsWastage: false,
                                SettingId: 0,
                                IsCustomerItem: false
                            }
                            // #region Labor 
                            let ItemLabor: JobWorkReturnLaborRow[] = RateHelper.GetPurchseLabour(laborcaloptions)
                            if (ItemLabor.length > 0)
                                for (var i = 0; i < ItemLabor.length; i++) {

                                    LaborRate += ItemLabor[i].LabourRate;
                                    labordetail.push(ItemLabor[i]);
                                }
                            // #endregion


                            // #endregion

                            var purity = 0;
                            var pureweight = 0;
                            if (!value.HasBom) {
                                purity = value.Purity;
                                pureweight = value.Weight * purity;
                            }
                            var purchase: JobWorkReturnItemsRow = {
                                ProductId: value.ProductId,
                                AttributeId: value.AttributeId,
                                Line_No: value.Line_No,
                                PartyId: value.PartyId,
                                SKU: SKU,
                                DepartmentId: value.DepartmentId,
                                ProductCode: value.ProductCode,
                                ProductName: value.ProductName,
                                ItemTypeId: value.ItemTypeId,
                                CategoryId: value.CategoryId,
                                ProductTypeId: value.ProductTypeId,
                                SubCategoryId: value.SubCategoryId,
                                BrandId: value.BrandId,
                                SuperTypeId: value.SuperTypeId,
                                CollectionId: value.CollectionId,
                                UnitRate: value.UnitRate,
                                UnitLabour: value.UnitLabour,
                                Pieces: value.Pieces,
                                Weight: 0.00,
                                OtherPieces: 0.00,
                                OtherWeight: 0.00,
                                StonePieces: 0.00,
                                StoneWeight: 0.00,
                                NetWeight: 0.00,
                                NetAmount: (Rate + LaborRate) * 1,
                                GrossAmount: (Rate + LaborRate) * 1,
                                DiamondPieces: value.DiamondPieces,
                                DiamondWeight: value.DiamondWeight,
                                CalcOnId: value.CalcOnId,
                                // BOMDetails: bomdetails,
                                LaborDetails: labordetail,
                                CompanyId: value.CompanyId,
                                HSN: value.HSN,
                                TaxCode: value.TaxCode,
                                RefTransId: value.TransId,
                                RefTransItemId: value.TransItemId,
                                Purity: purity,
                                PureWeight: pureweight,
                                HasBom: value.HasBom,
                                RefVoucherId: value.VoucherTypeId,
                                BagNo: value.BagNo,
                                CertificateNo: value.CertificateNo
                            };
                            orddetails.push(purchase);

                        });
                         
                        for (let orderDetail of orddetails) {
                            orderDetail[this.getIdProperty()] = "`" + this.nextId++;
                            this.view.addItem(orderDetail);
                        }
                    }
                    // #endregion

                    pickerDialog.dialogOpen();

                }
            });

            return buttons;
        }
    }
}